import { render, staticRenderFns } from "./verificationStatus.vue?vue&type=template&id=75d481d0&"
import script from "./verificationStatus.vue?vue&type=script&lang=js&"
export * from "./verificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports